import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import { FileGroupTypes } from "app/entities/enums";
import { AppService } from "app/services/app.service";
import { HelperService } from "app/services/helper.service";

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-media-upload-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class MediaUploadModalComponent extends ModalComponent implements OnInit {
  value: string;
  acceptsType: FileGroupTypes[] = ['video', 'image', 'doc'];
  accepts: string[] = HelperService.fileExt();
  maxSize = 5;
  maxFiles = 1;
  constructor(
    modalController: ModalController,
    private appService: AppService
  ) {
    super(modalController);
  }

  ngOnInit() {
  }

  closeModal() {
    return super.closeModal();
  }

  fileUpload($event: any) {
    let files = $event.target.files;

    if (files.length > 0) {
      files = [...files];

      const fileToUpload = files.filter((file) => this.validateSize(file) && this.validateExt(file));

      if (fileToUpload.length) {
        if (fileToUpload.length > this.maxFiles) {
          this.appService.showToast(`Можно залить только ${this.maxFiles} файлов`, 'danger');
        }
        super.closeModal({answer: fileToUpload});
      }

    }
  }

  validateSize(file: any) {
    const sizeMb = file.size / 1024 / 1024;

    if (parseFloat(sizeMb as any) > parseFloat(this.maxSize as any)) {
      this.appService.showToast(`Размер файла не должен превышать ${this.maxSize} Мб`, 'danger');

      return false;
    }

    return true;
  }

  validateExt(file: any) {
    const ext = this.HelperService.getNativeFileExt(file);

    if (this.accepts.includes(ext)) {
      return true;
    } else {
      this.appService.showToast(`Принимаются только ${this.accepts.join(', ')}`, 'danger');
      return false;
    }
  }
}
